import React from 'react';
import { Awards } from '../../../components/HOC/HOCDecoratedComponents';

export const AwardsList = props => {
        const { data, mode, guestMode } = props;
        return (
            <div className="list-achievements">
                { data.map((item) => {
                        item.numberButtons = 3;
                        return (
                            <div key={ item.id } className="item-wrapper">
                                <Awards componentData={ item } mode={ mode } guestMode={ guestMode } actionName="awardsApiCall"/>
                            </div>
                        )
                    })
                }
            </div>
        )
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/AwardsList.js